import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const PerformanceWrapper = styled(Box)`
  background: ${theme.colors.surfaceContainerBackground};
  border-radius: ${theme.attributes.borderRadius.tertiary};
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  /* Allow this flex child to shrink past its intrinsic content width.
     Without min-width:0, browsers fall back to min-width:auto and the
     sibling Benchmarking card gets pushed off-screen on zoom-in. */
  min-width: 0;
  height: 649px;
  box-sizing: border-box;

  .performance-top {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    padding: ${theme.spacing.medium}px ${theme.spacing.medium}px 8px;
    width: 100%;
    height: 242px;
    min-height: 242px;
    flex-shrink: 0;
    box-sizing: border-box;

    .section-header {
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing.xSmall}px;
      width: 100%;

      .title-row {
        display: flex;
        align-items: center;
        gap: 4px;

        .title-icon {
          width: 18px;
          height: 18px;
          color: ${theme.colors.menuItemText};
        }

        .title-text {
          font-family: ${theme.typography.fontFamily.primary};
          font-weight: ${theme.typography.fontWeight.bold};
          font-size: ${theme.typography.fontSize.header};
          color: ${theme.colors.menuItemText};
        }

        .info-icon-wrapper {
          display: flex;
          cursor: pointer;
          color: #6C5B67;

          &:hover {
            color: ${theme.colors.buttonHollowHover};
          }
        }
      }

      .last-update {
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.normal};
        font-size: ${theme.typography.fontSize.large};
        color: ${theme.colors.dropdownLabel};
        line-height: 22px;

        html[data-theme='light'] & {
          color: ${theme.colors.textCaption};
        }

        .date-value {
          color: ${theme.colors.menuItemText};
        }
      }
    }

    .donut-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${theme.spacing.xSmall}px;

      .change-indicator {
        display: flex;
        align-items: flex-end;
        gap: 6px;

        .change-value {
          display: flex;
          align-items: center;
          gap: 4px;

          .arrow-icon {
            display: block;
            flex-shrink: 0;
            width: 14px;
            height: 14px;
            stroke-width: 2;
          }

          .change-text {
            font-family: ${theme.typography.fontFamily.primary};
            font-weight: ${theme.typography.fontWeight.bold};
            font-size: ${theme.typography.fontSize.large};
            line-height: 20px;
          }

          &.positive {
            color: ${theme.colors.statusValueGood};
            .change-text {
              color: ${theme.colors.statusValueGood};
            }

            html[data-theme='light'] & {
              color: #22a06b;
              .change-text {
                color: #22a06b;
              }
            }
          }

          &.negative {
            color: #e74c3c;
            .arrow-icon {
              transform: rotate(180deg);
            }
            .change-text {
              color: #e74c3c;
            }

            html[data-theme='light'] & {
              color: ${theme.colors.statusValueBad};
              .change-text {
                color: ${theme.colors.statusValueBad};
              }
            }
          }
        }

        .since-label {
          font-family: ${theme.typography.fontFamily.primary};
          font-weight: ${theme.typography.fontWeight.normal};
          font-size: ${theme.typography.fontSize.large};
          color: ${theme.colors.dropdownLabel};
          line-height: 20px;
          letter-spacing: 0.25px;

          html[data-theme='light'] & {
            color: #6b6b76;
          }
        }
      }
    }
  }

  .performance-bottom {
    border-top: 1px solid ${theme.colors.borderMedium};
    padding: ${theme.spacing.medium}px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.large}px;
    flex: 1;

    .chart-controls {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: ${theme.spacing.small}px;
    }

    .history-last-update {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.normal};
      font-size: ${theme.typography.fontSize.large};
      color: ${theme.colors.dropdownLabel};
      line-height: 22px;

      html[data-theme='light'] & {
        color: ${theme.colors.textCaption};
      }

      .date-value {
        color: ${theme.colors.menuItemText};
      }
    }

    .empty-state {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 6px;
      max-width: 283px;
      margin: 0 auto;
      text-align: center;

      svg {
        margin-bottom: 10px;
      }

      .empty-title {
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.bold};
        font-size: ${theme.typography.fontSize.xLarge};
        color: ${theme.colors.menuItemText};
        line-height: 20px;
        letter-spacing: 0.016px;
      }

      .empty-description {
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.normal};
        font-size: ${theme.typography.fontSize.large};
        color: ${theme.colors.devicesSecondaryText};
        line-height: 20px;
      }
    }

    .chart-container {
      flex: 1;
      width: 100%;
      min-height: 200px;

      .recharts-cartesian-axis-tick text,
      .recharts-cartesian-axis-tick tspan {
        fill: ${theme.colors.chartAxisText} !important;
        color: ${theme.colors.chartAxisText} !important;
      }

      /* Let edge tick labels render past the SVG bounds into the surrounding
         padding instead of getting clipped. */
      .recharts-surface {
        overflow: visible;
      }
    }
  }
`
